export const getLiveChatScript = (sdkPath: string, scriptData: any) => {
  const settings = scriptData?.settings || {};
  const origin = typeof window !== 'undefined' ? window.location.origin : '';

  const rawScript = `<script>
(function(d, t) {
  var g = d.createElement(t),
      s = d.getElementsByTagName(t)[0];
  g.src = '${origin}${sdkPath}';
  g.defer = true;
  g.async = true;
  s.parentNode.insertBefore(g, s);
  g.onload = function() {
    window.liveChatSDK.run({
      websiteToken: "${settings.websiteToken || scriptData.websiteToken || scriptData.webToken || ''}",
      welcomeTitle: "${settings.welcomeTitle || scriptData.welcomeTitle || ''}",
      welcomeTagline: "${settings.welcomeTagline || scriptData.welcomeTagline || ''}",
      widgetColor: "${settings.widgetColor || scriptData.widgetColor || ''}",
      tenantId: "${scriptData.tenantId || settings.tenantId || ''}"
    });
  };
})(document, "script");
</script>`;

  const encoded = btoa(unescape(encodeURIComponent(rawScript)));

  return `<script>
(function(){
  const script = decodeURIComponent(escape(atob("${encoded}")));
  document.write(script);
})();
</script>`;
};

